import { gql, useQuery } from '@apollo/client';
import styled from '@emotion/styled';
import React from 'react';
import { useState } from 'react';
import { useCart } from '~Components/CartProvider';
import PredefinedMessages from '~Components/PredefinedMessages';
import Modal from '~ComponentsImproved/Modal';
import { useSelector } from '~Hooks';
import { BaseButton } from '~Scenes/Handy/styles';
import { GetPredefinedMessages, GetPredefinedMessagesVariables } from './__queries__';

const GET_PREDEFINED_MESSAGES = gql`
  query GetPredefinedMessages($id: ID!) {
    venue: Venue(id: $id) {
      id

      predefinedMessages {
        id
        message
        type
      }
    }
  }
`;

const Button = styled(BaseButton)`
  background: var(--colorBlueGray1300);
`;

interface Props {
  children: React.ReactNode;
}

const ItemMessageButton = ({ children }: Props) => {
  const venueId = useSelector((state) => state.venueId!);

  const [showMessageModal, setShowMessageModal] = useState<boolean>(false);
  const cart = useCart();
  const { data: messagesQuery } = useQuery<GetPredefinedMessages, GetPredefinedMessagesVariables>(
    GET_PREDEFINED_MESSAGES,
    {
      variables: {
        id: venueId,
      },
    },
  );

  const filteredMessages = messagesQuery?.venue?.predefinedMessages?.reduce(
    (messages: string[], item) => (item.type === 'ITEM' ? [...messages, item.message] : messages),
    [],
  );

  return (
    <>
      <Button onClick={() => setShowMessageModal(true)}>{children}</Button>
      {/* Modal for setting messages on items */}
      {showMessageModal && (
        <Modal
          isShowing={showMessageModal}
          hide={() => setShowMessageModal(false)}
          backdropClose={true}>
          <PredefinedMessages
            onSubmit={(value) => {
              cart.selectedItems.setMessage(typeof value === 'string' ? value : value.label);
              cart.selectedItems.clear();

              setShowMessageModal(false);
            }}
            messages={filteredMessages ?? []}
            value={cart.selectedItems.items.find((i) => i.message)?.message}
            buttonToOpenTextarea
          />
        </Modal>
      )}
    </>
  );
};

export default ItemMessageButton;
